'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadFireAlarm;

var _FireAlarmApp = require('FireAlarmUi/js/FireAlarmApp');

var _FireAlarmApp2 = _interopRequireDefault(_FireAlarmApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fireAlarmConfig = {
  appName: 'signup-ui',
  containers: {
    default: {
      before: document.querySelector('.page')
    }
  }
};

function loadFireAlarm() {
  var fireAlarm = new _FireAlarmApp2.default(window.hubspot, fireAlarmConfig);
  window.hubspot[_FireAlarmApp2.default.HUBSPOT_FIREALARM_KEY] = fireAlarm;
  fireAlarm.start();
}
module.exports = exports['default'];